<template>
  <div>
    <sc-form autocomplete="off" ref="credentialsForm">
      <template slot="fields" slot-scope="{ fields }">
        <div class="mainContent">
          <div v-if="!isEdit" class="mainContent__paragraphs">
            <p
              v-for="description in schemaBased.description"
              :key="description.id"
            >
              {{ description }}
            </p>
          </div>

          <div class="mainContent__table">
            <input-fields ref="inputFieldsRef" :schemaBased="schemaBased"/>
          </div>

        </div>
        <help-button />
      </template>

      <template slot="actions" slot-scope="{ isValid }">

        <div v-if="isEdit" class="editButtons">
          <sc-button
          class="startIntegration"
          text="Cancelar"
          theme="primary"
          />

          <sc-button
          class="startIntegration"
          text="Salvar"
          theme="primary"
          />
        </div>

        <div v-else class="navigateButtons">
          <sc-button
          class="startIntegration"
          text="Próximo"
          theme="primary"
          @click="navigateNext"
          type="submit"
          />
        </div>

      </template>
    </sc-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScButton,
  ScForm,
  ScField,
  ScInput,
  ScToast,
  ScTooltip,
  ScIcon,
} from '@intelipost-js/secure-components';
import HelpButton from '../help-button/HelpButton.vue';
import InputFields from '../input-fields/InputFields.vue';

const { mapState, mapMutations } = createNamespacedHelpers(
  'integrations/integrationsStep',
);

export default {
  name: 'sc-credentials',

  props: {
    schemaBased: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      is_per_warehouse: false,
      per_warehouse: [],
    };
  },
  computed: {
    ...mapState(['appDetails', 'appConfigV2']),
  },
  methods: {
    ...mapMutations(['nextStep', 'setAppConfigV2']),

    navigateNext() {
      const inputFieldsComponent = this.$refs.inputFieldsRef;
      let app_config;
      inputFieldsComponent.alreadyChecked = true;

      this.is_per_warehouse = JSON.parse(this.appDetails.app.schemaBased).is_per_warehouse;


      if (this.is_per_warehouse) {
        for (const warehouseConfig of inputFieldsComponent.per_warehouse) {
          if (!inputFieldsComponent.validateConfig(warehouseConfig)) {
            this.$refs.warehouseListComponent.setSelectedWarehouse(warehouseConfig.warehouse_id);
            return;
          }
        }
        app_config = {
          per_warehouse: inputFieldsComponent.per_warehouse,
        };
      } else {
        if (!inputFieldsComponent.validateConfig(inputFieldsComponent.formFields)) {
          return;
        }
        app_config = inputFieldsComponent.formFields;
      }

      if (app_config) {
        this.setAppConfigV2(app_config);
        this.nextStep();
      }
    },

  },

  components: {
    ScButton,
    ScForm,
    ScField,
    ScInput,
    ScToast,
    ScTooltip,
    ScIcon,
    HelpButton,
    InputFields,
  },
};
</script>

<style lang='scss' scoped>
.mainContent {
  display: flex;
  flex-direction: column;
  gap: 40px;

  &__paragraphs {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__inputs {
    display: flex;
    flex-direction: column;
    gap: 30px;
    max-width: 500px;
  }

  &__input {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-credentials/ScCredentials.vue?0364abec